import { render, staticRenderFns } from "./DigitalModule.vue?vue&type=template&id=5a8533d1&"
import script from "./DigitalModule.vue?vue&type=script&lang=js&"
export * from "./DigitalModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports